var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from "moment";
import { Type, PredefinedWoType, PredefinedClient, FileType, PredefinedClientName, SelectScheduleTimeType, PredefinedClientCode, AmplitudeProjectName } from "@common/enums/base";
import { isArray, isObject, camelCase, isPlainObject, has } from "lodash-es";
import { AbFeatures, hasAbFeature } from "./abFeature";
import Cookies from "js-cookie";
import { loginPageHashToRedirectUrl, currentPageHashToReturnUrl } from "./url";
import { initUserProperties, sendAmplitudeLogEvent } from "one-amplitude";
import heic2any from "heic2any";
import { RES_PATH } from "@common/config";
export var type = function (obj) {
    var type = Object.prototype.toString.call(obj);
    return type.substring(8, type.length - 1);
};
export var setToken = function (token) {
    var date = new Date();
    var minute = date.getMinutes() + 60 * 12;
    date.setMinutes(minute);
    localStorage.setItem("token", token);
    localStorage.setItem("expire", date.toString());
};
export var getToken = function () {
    var token = localStorage.getItem("token");
    if (token) {
        return token;
    }
};
export var removeToken = function () {
    localStorage.removeItem("token");
    localStorage.removeItem("expire");
};
export var getEncodePath = function () {
    var location = window.location;
    if (location.pathname === "/login") {
        return false;
    }
    var encodePath = encodeURIComponent(location.pathname + location.search);
    return "returnUrl=" + encodePath;
};
export var isEmpty = function (obj) {
    if (type(obj) === Type.Array) {
        return obj.length === 0;
    }
    if (type(obj) === Type.Object) {
        return Object.keys(obj).length === 0;
    }
    return !obj;
};
export var dateTimeText = function (f, dateOnly) {
    if (dateOnly === void 0) { dateOnly = false; }
    return f ? moment(f).format(dateOnly ? "MM/DD/YYYY" : "MM/DD/YYYY hh:mm:ss A") : "";
};
export function toCamelCaseData(data) {
    if (!data)
        return data;
    if (isArray(data)) {
        return data.map(function (x) { return toCamelCaseData(x); });
    }
    if (isObject(data)) {
        var obj = {};
        for (var prop in data) {
            // @ts-ignore
            var val = data[prop];
            if (isPlainObject(val)) {
                obj[camelCase(prop)] = toCamelCaseData(val);
            }
            else if ($.isArray(val)) {
                obj[camelCase(prop)] = val.map(function (x) { return toCamelCaseData(x); });
            }
            else {
                obj[camelCase(prop)] = val;
            }
        }
        return obj;
    }
    return data;
}
export var generatorUniformQueryResult = function (Mapping) {
    return function (queryArr) {
        if (!queryArr) {
            return [];
        }
        var map = null;
        return queryArr.map(function (item) {
            if (type(item) === Type.Object) {
                !map &&
                    Mapping.some(function (temp) {
                        if (has(item, temp[0]) && has(item, temp[1])) {
                            map = temp;
                            return true;
                        }
                        return false;
                    });
                return map ? __assign(__assign({}, item), { name: item[map[1]], id: item[map[0]] }) : __assign({}, item);
            }
            return { name: item, id: item };
        });
    };
};
var Mapping = [["Key", "Value"], ["Id", "Name"]];
export var uniformQueryResult = generatorUniformQueryResult(Mapping);
export var formatPhone = function (phone) {
    var phoneNumber = phone.replace(/\D/g, "");
    var partA = phoneNumber.substring(0, 3);
    var partB = phoneNumber.substring(3, 6);
    var partC = phoneNumber.substring(6, 10);
    // 2345678  =>  234-567-8
    if (partC) {
        return "(" + partA + ") " + partB + "-" + partC;
    }
    // 2345 => 234-5
    if (partB) {
        return partA + "-" + partB;
    }
    return phoneNumber;
};
export var direction = function (windSpeed) {
    if (windSpeed >= 0 && windSpeed < 11.25) {
        return "N";
    }
    if (windSpeed >= 11.25 && 33.75 > windSpeed) {
        return "NNE";
    }
    if (windSpeed >= 33.75 && 56.25 > windSpeed) {
        return "NE";
    }
    if (windSpeed >= 56.25 && 78.75 > windSpeed) {
        return "ENE";
    }
    if (windSpeed >= 78.75 && 101.25 > windSpeed) {
        return "E";
    }
    if (windSpeed >= 101.25 && 123.75 > windSpeed) {
        return "ESE";
    }
    if (windSpeed >= 123.75 && 146.25 > windSpeed) {
        return "SE";
    }
    if (windSpeed >= 146.25 && 168.75 > windSpeed) {
        return "SSE";
    }
    if (windSpeed >= 168.75 && 191.25 > windSpeed) {
        return "S";
    }
    if (windSpeed >= 191.25 && 213.75 > windSpeed) {
        return "SSW";
    }
    if (windSpeed >= 213.75 && 236.25 > windSpeed) {
        return "SW";
    }
    if (windSpeed >= 236.25 && 258.75 > windSpeed) {
        return "WSW";
    }
    if (windSpeed >= 258.75 && 281.25 > windSpeed) {
        return "W";
    }
    if (windSpeed >= 281.25 && 303.75 > windSpeed) {
        return "WNW";
    }
    if (windSpeed >= 303.75 && 326.25 > windSpeed) {
        return "NW";
    }
    if (windSpeed >= 326.25 && 348.75 > windSpeed) {
        return "NNW";
    }
    if (windSpeed >= 348.75 && 360 > windSpeed) {
        return "N";
    }
};
export var categoryIcon = function (categoryName) {
    if (!categoryName) {
        return;
    }
    var categoryIconClasses = [
        "air",
        "appliances",
        "cabinets",
        "doors",
        "electrical",
        "flooring",
        "garage",
        "general",
        "landscape",
        "masonry",
        "pest",
        "paint",
        "carpet",
        "plumbing",
        "pool",
        "roof",
        "window"
    ];
    var defaultCategoryIconClass = "icon-default";
    var tmp = categoryName.split(" ")[0];
    tmp = tmp.split("/");
    var className = tmp[0].toLowerCase();
    var i = categoryIconClasses.findIndex(function (item) {
        return item === className;
    });
    if (i === -1) {
        return defaultCategoryIconClass;
    }
    return "icon-" + className;
};
export var fileIcon = function (fileName) {
    var result = /\.[^\.]+/.exec(fileName);
    var suffix = result ? result[0].substr(1) : '';
    var outsideIcon = 'file-unknow';
    var insideIcon = 'icon-other2';
    ['xls', 'xlsx', 'XLS', 'XLSX'].some(function (item) {
        return item === suffix;
    }) && (outsideIcon = 'file-xls', insideIcon = 'icon-xls');
    ['mp3', 'MP3'].some(function (item) {
        return item === suffix;
    }) && (outsideIcon = 'file-voice', insideIcon = 'icon-mp3');
    ['mp4', 'MP4', 'hevc', 'HEVC'].some(function (item) {
        return item === suffix;
    }) && (outsideIcon = 'file-video', insideIcon = 'icon-mp4');
    ['ppt', 'PPT', 'pptx', 'PPTX'].some(function (item) {
        return item === suffix;
    }) && (outsideIcon = 'file-ppt', insideIcon = 'icon-ppt');
    ['doc', 'DOC', 'docx', 'DOCX'].some(function (item) {
        return item === suffix;
    }) && (outsideIcon = 'file-doc', insideIcon = 'icon-doc');
    ['pdf', 'PDF'].some(function (item) {
        return item === suffix;
    }) && (outsideIcon = 'file-pdf', insideIcon = 'icon-pdf');
    return {
        outsideIcon: outsideIcon,
        insideIcon: insideIcon
    };
};
export var getSearchParam = function (search, name) {
    // Case-insensitive: the legacy pages spell these params differently to the SPA
    // (e.g. `isreactive` vs `isReactive`), and their links have to keep working
    // once the old addresses redirect here.
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", 'i');
    var res = search.substr(1).match(reg);
    if (res) {
        return unescape(res[2]);
    }
    return null;
};
/**
 * Reads the `Link` query param as the whole rest of the URL.
 *
 * The legacy /RSP/SMSU/Video and /RSP/SMSU/Guide pages are linked to with
 * `?name=<FileName>&Link=<FileUrl>` built by raw string concatenation, so the
 * file URL keeps its own unescaped query string (`?sv=...&Expires=...&Signature=...`).
 * Parsing `Link` normally would cut it at the first `&` and drop the signature,
 * which is why those pages re-attached the `Expires` tail by hand. Taking
 * everything after `Link=` keeps the URL intact whether or not it was encoded.
 *
 * `Link` must therefore stay the last param in the URL.
 */
export var getLinkParam = function (search) {
    var res = /[?&]Link=(.*)$/i.exec(search);
    if (!res || !res[1]) {
        return null;
    }
    var raw = res[1];
    // Decode only a wholly percent-encoded URL, which has no literal "://" of its own.
    // Decoding a raw URL would also unescape its signature (sig=a%2Bb%2Fc%3D), and a
    // pre-signed link stops working once those characters are turned into + / = .
    return raw.indexOf('://') === -1 && /%3A%2F%2F/i.test(raw)
        ? decodeURIComponent(raw)
        : raw;
};
export var scheduleTimeText = function (blockStartTime, blockEndTime, woTypeId, isCutMoreThan5hours) {
    if (isCutMoreThan5hours === void 0) { isCutMoreThan5hours = true; }
    var blockStartTimes = moment.utc(blockStartTime);
    var blockEndTimes = moment.utc(blockEndTime);
    var res = null;
    var isInHouseOrProcare = [PredefinedWoType.InHouseTechnician, PredefinedWoType.ProCare].indexOf(woTypeId) > -1;
    if (isInHouseOrProcare &&
        (isIH() || isWPH()) &&
        (hasAbFeature(AbFeatures.AutoSchedule) || Cookies.get("isAutoScheduleRegion"))) {
        if (isCutMoreThan5hours && blockEndTimes.hour() - blockStartTimes.hour() > 5) {
            // cp-1178
            if (blockStartTimes.hour() === 10) {
                return " " + blockStartTimes.hour(10).format("h:mm A") + " - " + blockEndTimes.hour(14).format("h:mm A");
            }
            if (blockStartTimes.hour() === 8) {
                return " " + blockStartTimes.hour(8).format("h:mm A") + " - " + blockEndTimes.hour(12).format("h:mm A");
            }
        }
        return " " + blockStartTimes.format("h:mm A") + " - " + blockEndTimes.format("h:mm A");
    }
    if (blockStartTimes.hour() === 10 &&
        blockEndTimes.hour() === 14 &&
        blockStartTimes.minute() === 0 &&
        blockEndTimes.minute() === 0 &&
        blockStartTimes.day() === blockEndTimes.day()) {
        return (res = " 10:00 AM - 2:00 PM");
    }
    if (blockStartTimes.hour() >= 8 && blockStartTimes.hour() < 12) {
        res = " 8:00 AM - 12:00 PM";
    }
    else if (blockStartTimes.hour() >= 12 && blockStartTimes.hour() < 17) {
        res = " 12:00 PM - 5:00 PM";
    }
    else if (blockStartTimes.hour() <= 8 || blockStartTimes.hour() >= 17) {
        res = " 5:00 PM - 8:00 AM";
    }
    return res;
};
export var scheduleStartTimeText = function (blockStartTime, blockEndTime, woTypeId) {
    if (!blockStartTime || !blockEndTime) {
        return null;
    }
    var blockStartTimes = moment.utc(blockStartTime);
    var blockEndTimes = moment.utc(blockEndTime);
    if (woTypeId === PredefinedWoType.InHouseTechnician &&
        (isIH() || isWPH()) &&
        (hasAbFeature(AbFeatures.AutoSchedule) || Cookies.get("isAutoScheduleRegion"))) {
        return moment.utc(blockStartTimes).format("MM/DD/YYYY h:mm A");
    }
    var res = null;
    if (blockStartTimes.hour() === 10 &&
        blockEndTimes.hour() === 14 &&
        blockStartTimes.minute() === 0 &&
        blockEndTimes.minute() === 0 &&
        blockStartTimes.day() === blockEndTimes.day()) {
        return (res = moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 10:00 AM");
    }
    if (blockStartTimes.hour() >= 8 && blockStartTimes.hour() < 12) {
        res = moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 8:00 AM";
    }
    else if (blockStartTimes.hour() >= 12 && blockStartTimes.hour() < 17) {
        res = moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 12:00 AM";
    }
    else if (blockStartTimes.hour() >= 17) {
        res = moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 5:00 PM";
    }
    else if (blockStartTimes.hour() <= 8) {
        blockStartTimes = blockStartTimes.add(-1, "d");
        res = moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 5:00 PM";
    }
    return res;
};
export var scheduleEndTimeText = function (blockStartTime, blockEndTime, woTypeId) {
    if (!blockStartTime || !blockEndTime) {
        return null;
    }
    var blockStartTimes = moment.utc(blockStartTime);
    var blockEndTimes = moment.utc(blockEndTime);
    var res = null;
    if (woTypeId === PredefinedWoType.InHouseTechnician &&
        (isIH() || isWPH()) &&
        (hasAbFeature(AbFeatures.AutoSchedule) || Cookies.get("isAutoScheduleRegion"))) {
        return moment.utc(blockEndTimes).format("MM/DD/YYYY h:mm A");
    }
    if (blockStartTimes.hour() === 10 &&
        blockEndTimes.hour() === 14 &&
        blockStartTimes.minute() === 0 &&
        blockEndTimes.minute() === 0 &&
        blockStartTimes.day() === blockEndTimes.day()) {
        return moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 10:00 AM";
    }
    if (blockStartTimes.hour() >= 8 && blockStartTimes.hour() < 12) {
        res = moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 12:00 PM";
    }
    else if (blockStartTimes.hour() >= 12 && blockStartTimes.hour() < 17) {
        res = moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 5:00 PM";
    }
    else if (blockStartTimes.hour() >= 17) {
        blockStartTimes = blockStartTimes.add(1, "d");
        res = moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 8:00 AM";
    }
    else if (blockStartTimes.hour() <= 8) {
        res = moment.utc(blockStartTimes).format("MM/DD/YYYY") + " 8:00 AM";
    }
    return res;
};
export var isRW = function () {
    return Cookies.get("clientId") === PredefinedClient.RentersWarehouse.toString();
};
export var isWPH = function () {
    return Cookies.get("clientId") === PredefinedClient.WPH.toString();
};
export var isIH = function () {
    return Cookies.get("clientId") === PredefinedClient.IH.toString();
};
export var isTRI = function () {
    return Cookies.get("clientId") === PredefinedClient.Tricon.toString();
};
export var isHPA = function () {
    return Cookies.get("clientId") === PredefinedClient.HPA.toString();
};
export var isBHI = function () {
    return Cookies.get("clientCode") === PredefinedClientCode.BHI;
};
export var isDAR = function () {
    return Cookies.get("clientId") === PredefinedClient.DAR.toString();
};
export var isWPHEnableIHTheme = function () {
    return true;
};
export var clientName = function () {
    var id = Cookies.get("clientId") ? parseInt(Cookies.get("clientId"), 0) : PredefinedClient.WPH;
    if (isWPHEnableIHTheme()) {
        id = id === PredefinedClient.WPH ? PredefinedClient.IH : id;
    }
    return PredefinedClientName[id];
};
export var fileTypeFromFileName = function (filename) {
    var extension = filename.substr(filename.lastIndexOf("."), filename.length).toLowerCase();
    switch (extension) {
        case ".doc":
        case ".docx":
            return FileType.Word;
        case ".xls":
        case ".xlsx":
            return FileType.Excel;
        case ".pdf":
            return FileType.Pdf;
        case ".msg":
            return FileType.Msg;
        case ".avi":
        case ".mov":
        case ".3gp":
        case ".rmvb":
        case ".rm":
        case ".asf":
        case ".divx":
        case ".mpg":
        case ".mpeg":
        case ".mpe":
        case ".wmv":
        case ".mp4":
        case ".mkv":
        case ".vob":
            return FileType.Video;
        case ".jpg":
        case ".jpeg":
        case ".png":
        case ".ico":
        case ".gif":
        case ".bmp":
            return FileType.Image;
        case ".mp3":
        case ".wav":
        case ".m4a":
            return FileType.Mp3;
        default:
            return FileType.Unknown;
    }
};
export var caculateMinWorkDate = function (now, day, isHoliday) {
    if (day < 2) {
        if (now.getDay() === 0 || now.getDay() === 6 || isHoliday(now)) {
            now.setDate(now.getDate() + 1);
            caculateMinWorkDate(now, day, isHoliday);
        }
        else {
            now.setDate(now.getDate() + 1);
            caculateMinWorkDate(now, day + 1, isHoliday);
        }
    }
    else {
        if (now.getDay() === 0 || now.getDay() === 6 || isHoliday(now)) {
            now.setDate(now.getDate() + 1);
            caculateMinWorkDate(now, day, isHoliday);
        }
    }
    return now;
};
export var isInHolidays = function (date, holidays) {
    var m = date.getMonth();
    var d = date.getDate();
    var y = date.getFullYear();
    return holidays.some(function (holiday) {
        if (type(holiday) === Type.Number) {
            return holiday === date.getDay() + 1;
        }
        if (type(holiday) === Type.Array) {
            return y === holiday[0] && m === holiday[1] && d === holiday[2];
        }
    });
};
export var extractTimeOfSlotFn = function (selectedSlots) {
    var times = selectedSlots.map(function (item) {
        var start = moment(item.schedulestarttime).format("MM/DD/YY hh:mm A");
        var end = moment(item.scheduleendtime).format("MM/DD/YY hh:mm A");
        return start + " - " + end + " " + (item._rank + 1);
    });
    var isRecommendationSlot = "0";
    if (selectedSlots.length === 0) {
        isRecommendationSlot = "0";
    }
    else if (selectedSlots.every(function (item) { return item.isRecommend; })) {
        isRecommendationSlot = "1";
    }
    else {
        isRecommendationSlot = "2";
    }
    return { isRecommendationSlot: isRecommendationSlot, extractTimeOfSlot: times };
};
export var redirectToLoginPage = function (searchUrl) {
    if (searchUrl === void 0) { searchUrl = ""; }
    history.replaceState(null, null, document.location.pathname + "#/account/login" + searchUrl);
    location.reload();
};
export var redirectToMainPage = function () {
    history.replaceState(null, null, document.location.pathname + "#/" + loginPageHashToRedirectUrl());
    location.reload();
};
export var redirectToCompleteAccountPage = function (searchUrl) {
    if (searchUrl === void 0) { searchUrl = ""; }
    history.replaceState(null, null, document.location.pathname + "#/completeAccount" + searchUrl);
    location.reload();
};
export var redirectToResetPasswordPage = function () {
    history.replaceState(null, null, document.location.pathname + "#/account/resetPasswordInfo");
    location.reload();
};
export var redirectToIndex = function () {
    history.replaceState(null, null, document.location.pathname + "#/");
    location.reload();
};
export var redirectToLoginPageWithReturnUrl = function () {
    var isAccountPage = window.location.hash
        .slice(2)
        .toLowerCase()
        .startsWith('account');
    if (!isAccountPage) {
        redirectToLoginPage(currentPageHashToReturnUrl());
    }
};
export var isDevelopment = function () {
    return process.env.NODE_ENV === "development";
};
var locationId = null;
export var setLocationId = function (id) {
    locationId = id;
};
export var getLocationId = function () { return locationId || Cookies.get("locationId"); };
export var isMobile = (function () {
    if (/mobile|iphone|ipod|ios|phone/i.test(navigator.userAgent.toLowerCase())) {
        return true;
    }
    if (/android/i.test(navigator.userAgent.toLowerCase()) && /mobile/i.test(navigator.userAgent.toLowerCase())) {
        return true;
    }
    return false;
})();
export function initFavicon(currentClientId) {
    var head = document.head;
    var items = head.querySelectorAll("link[data-favicon]");
    Array.from(items).forEach(function (x) { return head.removeChild(x); });
    var sourcesPath = RES_PATH + "sources/img/";
    var clientId = currentClientId || Cookies.get("clientId");
    var isIH = clientId === PredefinedClient.IH.toString() && !hasAbFeature(AbFeatures.Sandbox);
    var iconLinks = isIH
        ? [
            { rel: "icon", href: sourcesPath + "favicon.png" },
            { rel: "apple-touch-icon", href: sourcesPath + "apple-touch-icon.png" },
            { rel: "apple-touch-icon", href: sourcesPath + "apple-touch-icon-72x72.png" },
            { rel: "apple-touch-icon", href: sourcesPath + "apple-touch-icon-144x144.png" },
        ]
        : [{ rel: "icon", href: sourcesPath + "favicon.ico" }];
    iconLinks.forEach(function (_a) {
        var rel = _a.rel, href = _a.href;
        var link = document.createElement("link");
        link.setAttribute("rel", rel);
        link.setAttribute("href", href);
        link.setAttribute("data-favicon", "");
        head.appendChild(link);
    });
}
var classList = ["ih", "gps", "hp"];
export function getClientCode(code) {
    if (classList.some(function (x) { return x === code; })) {
        return code;
    }
    return "sms";
}
export var generateDeferred = function () {
    var resolve;
    var reject;
    var promise = new Promise(function (lresolve, lreject) {
        resolve = lresolve;
        reject = lreject;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject,
        then: promise.then.bind(promise)
    };
};
var encodeCanvas2Image = function (canvas, quality) {
    var data = canvas.toDataURL("image/jpeg", quality || 1);
    data = data.split(',')[1];
    data = atob(data);
    var imageArray = new Uint8Array(data.length);
    for (var i = 0; i < data.length; i += 1) {
        imageArray[i] = data.charCodeAt(i);
    }
    return new Blob([imageArray], {
        type: "image/jpeg"
    });
};
var calcLimitSize = function (width, height, maxWidth, maxHeight) {
    if (width > 0 && height > 0) {
        if (width / height >= maxWidth / maxHeight) {
            return width > maxWidth ? {
                width: maxWidth,
                height: (height * maxWidth) / width
            } : {
                width: width,
                height: height
            };
        }
        return height > maxHeight ? {
            height: maxHeight,
            width: (width * maxHeight) / height
        } : {
            width: width,
            height: height
        };
    }
};
export var compressImage = function (file, limitSize) {
    var limit = __assign({
        width: 2560,
        height: 1440,
        quality: .6
    }, (limitSize || {}));
    return new Promise(function (resolve, reject) {
        var _a, _b;
        var processImage = function (imageSrc) {
            var image = new Image();
            image.onload = function () {
                var naturalWidth = image.naturalWidth, naturalHeight = image.naturalHeight;
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                try {
                    var _a = calcLimitSize(naturalWidth, naturalHeight, limit.width, limit.height), width = _a.width, height = _a.height;
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(image, 0, 0, naturalWidth, naturalHeight, 0, 0, width, height);
                    var result = encodeCanvas2Image(canvas, limit.quality);
                    result.name = file.name;
                    result.lastModified = file.lastModified;
                    resolve({
                        width: width,
                        height: height,
                        image: result,
                    });
                }
                catch (e) {
                    reject(new Error("Compress image error: " + e.stack));
                }
            };
            image.onerror = function () {
                reject(new Error("File to be compressed must be image, check your file type..."));
            };
            image.src = imageSrc;
        };
        if ((((_a = file === null || file === void 0 ? void 0 : file.name) === null || _a === void 0 ? void 0 : _a.includes('.heic')) || ((_b = file === null || file === void 0 ? void 0 : file.name) === null || _b === void 0 ? void 0 : _b.includes('.heif')))) {
            heic2any({ blob: file, toType: 'image/jpeg' })
                .then(function (convertedBlob) {
                var reader = new FileReader();
                reader.onload = function () {
                    processImage(reader.result);
                };
                reader.readAsDataURL(convertedBlob);
            })
                .catch(function (e) {
                reject(new Error("HEIF/HEIC conversion error: " + e.message));
            });
        }
        else {
            var fileReader_1 = new FileReader();
            fileReader_1.onload = function () {
                processImage(fileReader_1.result);
            };
            fileReader_1.readAsDataURL(file);
        }
    });
};
export var getIsRecommendationSlot = function (selectScheduleTimeList) {
    var isRecommendationSlot = selectScheduleTimeList.length > 0 ?
        selectScheduleTimeList[0].isRecommend ? SelectScheduleTimeType.SelectRecommendedTime :
            SelectScheduleTimeType.SelectCommonTime : SelectScheduleTimeType.NotSelectTime;
    return isRecommendationSlot.toString();
};
export var getTimeOfSlotRank = function (selectScheduleTimeList) {
    return selectScheduleTimeList.map(function (item) {
        return moment(item.scheduleStartTime).format('MM/DD/YYYY hh:mm A') + " - " + moment(item.scheduleEndTime)
            .format('MM/DD/YYYY hh:mm A') + "  " + item.indexOf + " ";
    }).join(',');
};
export var isStageEnvironment = function () {
    return window.location.hostname.indexOf("onestage.lessen.com") > 0 || window.location.hostname.indexOf("onestage.smsassist.com") > 0;
};
export var isDevEnvironment = function () {
    return window.location.hostname.indexOf("onedev.lessen.com") > 0 || window.location.hostname.indexOf("onedev.smsassist.com") > 0;
};
export var isLocalhostEnvironment = function () {
    return window.location.hostname === "localhost";
};
export var isTestSpeechFeatureEnabled = function () {
    return localStorage && localStorage.getItem('SpeechFeatureEnabled') === 'true';
};
export var isLiveEnvironment = function () {
    return window.location.hostname.indexOf("one.lessen.com") > 0 || window.location.hostname.indexOf("one.smsassist.com") > 0;
};
export var isTestingEnvironment = function () {
    return window.location.hostname.indexOf("onetest.lessen.com") > 0 || window.location.hostname.indexOf("onetest.smsassist.com") > 0;
};
export var isIHUrl = function () {
    return window.location.hostname.indexOf("ihrsp") > 0;
};
export var isDemoCenterEnvironment = function () {
    return window.location.hostname.indexOf("democenter") > 0;
};
export var getCurrentEnv = function () {
    if (isLiveEnvironment()) {
        return "live";
    }
    if (isStageEnvironment()) {
        return "stage";
    }
    if (isDevEnvironment()) {
        return "dev";
    }
    if (isLocalhostEnvironment()) {
        return "localhost";
    }
    if (isDemoCenterEnvironment()) {
        return "democenter";
    }
};
export var IsNotString = function (data) {
    return data && typeof data !== 'string';
};
export var sendAmplitude_AAC = function (logEvent, currentUser, paramInfo) {
    if (currentUser === void 0) { currentUser = "default"; }
    var projectName = "Coca-cola";
    var browserName = getBrowserType();
    var phoneType = getPlatform();
    var userId = Cookies.get('userId') || "";
    var userName = Cookies.get('userName') || "";
    initUserProperties("explaintion", currentUser, projectName);
    initUserProperties("userId", userId, projectName);
    initUserProperties("userName", userName, projectName);
    initUserProperties("browserName", browserName, projectName);
    initUserProperties("phoneType", phoneType, projectName);
    sendAmplitudeLogEvent(logEvent, {}, projectName);
};
export var sendAmplitude_Otp = function (currentUser, logEvent, paramInfo) {
    var projectName = AmplitudeProjectName.ARK_RSP_OTP;
    var browserName = getBrowserType();
    var phoneType = getPlatform();
    var clientId = Cookies.get("clientId");
    initUserProperties("clientId", clientId, projectName);
    initUserProperties("browserName", browserName, projectName);
    initUserProperties("phoneType", phoneType, projectName);
    sendAmplitudeLogEvent(logEvent, {}, projectName);
};
export var sendAmplitude_Default = function (logEvent, data) {
    sendAmplitudeLogEvent(logEvent, data, AmplitudeProjectName.Default);
};
export function getBrowserType() {
    var ua = navigator.userAgent.toLocaleLowerCase();
    var browserType = null;
    if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
        browserType = 'IE';
    }
    else if (ua.match(/firefox/) != null) {
        browserType = 'firefox';
    }
    else if (ua.match(/ucbrowser/) != null) {
        browserType = 'UC';
    }
    else if (ua.match(/opera/) != null || ua.match(/opr/) != null) {
        browserType = 'opera';
    }
    else if (ua.match(/bidubrowser/) != null) {
        browserType = 'baidu';
    }
    else if (ua.match(/metasr/) != null) {
        browserType = 'sougou';
    }
    else if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        browserType = 'QQ';
    }
    else if (ua.match(/maxthon/) != null) {
        browserType = 'maxthon';
    }
    else if (ua.match(/chrome/) != null) {
        browserType = 'chrome';
    }
    else if (ua.match(/safari/) != null) {
        browserType = 'Safari';
    }
    else {
        browserType = 'others';
    }
    return browserType;
}
export var getPlatform = function () {
    var ua = navigator.userAgent, isWindowsPhone = /(?:Windows Phone)/.test(ua), isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone, isAndroid = /(?:Android)/.test(ua), isFireFox = /(?:Firefox)/.test(ua), isChrome = /(?:Chrome|CriOS)/.test(ua), isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)), isPhone = /(?:iPhone)/.test(ua) && !isTablet, isPc = !isPhone && !isAndroid && !isSymbian;
    var os = {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
    if (os.isAndroid) {
        return "Android";
    }
    if (os.isPhone) {
        return "Iphone";
    }
    if (os.isTablet) {
        return "IPad";
    }
    return "LaptopOrDesktop";
};
export var isDisableMenuBar = function () {
    return Cookies.get("disableMenuBar") === 'true';
};
export var iframePostMessage = function (type, data) {
    var _a;
    if (data === void 0) { data = {}; }
    (_a = window === null || window === void 0 ? void 0 : window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({ type: type, data: data }, '*');
};
